import DApp from "../Diathrive/App";
import { useFonts } from "expo-font";
import { WEB_FONTS } from "./src/utils/Constants";
import { minWidth800 } from "./globalStyles";
import { useEffect } from "react";
import { setupAnalytics } from "../Diathrive/src/utils/Analytics";

export default function App() {
  const [fontsLoaded] = useFonts(WEB_FONTS);

  useEffect(() => {
    // Initialize PostHog analytics for web
    setupAnalytics();
  }, []);

  if (!fontsLoaded) return null;

  return (
    <div style={minWidth800}>
      <DApp />
    </div>
  );
}
